import { outbrainMixins } from './outbrainPlacementWidgets'
import { styleMixins } from '../../common/ad_ops/styleMixins'
import type { AdPlacement } from '@duplex/common/ad_ops/adPlacementMappings'
import { getNTPTaboolaWidgetForPlacement } from '@duplex/common/ad_ops/taboolaPlacementUtil'
import { taboolaMixins } from './taboolaPlacementWidgets'

export const placementConfigs: Record<string, AdPlacement> = {
  // Section placements
  sectiontab_300x250: {
    outbrain: { ...outbrainMixins.AR_38 },
    style: { ...styleMixins[304_300] },
    taboola: getNTPTaboolaWidgetForPlacement('sectiontab-300x250'),
    assertive: {},
    props: {},
  },
  sectiontab_r1_c1: {
    outbrain: { ...outbrainMixins.AR_38 },
    style: { ...styleMixins[304_300] },
    taboola: getNTPTaboolaWidgetForPlacement('sectiontab-r1-c1'),
    assertive: {},
    props: {},
  },
  sectiontab_r1_c3: {
    outbrain: { ...outbrainMixins.AR_38 },
    style: { ...styleMixins[304_300] },
    taboola: getNTPTaboolaWidgetForPlacement('sectiontab-r1-c3'),
    assertive: {},
    props: {},
  },
  sectiontab_r1_c4: {
    outbrain: { ...outbrainMixins.AR_38 },
    style: { ...styleMixins[304_300] },
    taboola: getNTPTaboolaWidgetForPlacement('sectiontab-r1-c4'),
    assertive: {},
    props: {},
  },
  sectiontab_r1_c5: {
    outbrain: { ...outbrainMixins.AR_38 },
    style: { ...styleMixins[304_300] },
    taboola: getNTPTaboolaWidgetForPlacement('sectiontab-r1-c5'),
    assertive: {},
    props: {},
  },

  sectiontab_r2_c2: {
    outbrain: { ...outbrainMixins.AR_38 },
    style: { ...styleMixins[304_300] },
    taboola: getNTPTaboolaWidgetForPlacement('sectiontab-r2-c2'),
    assertive: {},
    props: {},
  },

  sectiontab_r2_c4: {
    outbrain: { ...outbrainMixins.AR_38 },
    style: { ...styleMixins[304_300] },
    taboola: getNTPTaboolaWidgetForPlacement('sectiontab-r2-c4'),
    assertive: {},
    props: {},
  },

  sectiontab_r3_c1: {
    outbrain: { ...outbrainMixins.AR_38 },
    style: { ...styleMixins[304_300] },
    taboola: getNTPTaboolaWidgetForPlacement('sectiontab-r3-c1'),
    assertive: {},
    props: {},
  },
  sectiontab_r3_c3: {
    outbrain: { ...outbrainMixins.AR_38 },
    style: { ...styleMixins[304_300] },
    taboola: getNTPTaboolaWidgetForPlacement('sectiontab-r3-c3'),
    assertive: {},
    props: {},
  },
  sectiontab_r3_c4: {
    outbrain: { ...outbrainMixins.AR_38 },
    style: { ...styleMixins[304_300] },
    taboola: getNTPTaboolaWidgetForPlacement('sectiontab-r3-c4'),
    assertive: {},
    props: {},
  },
  sectiontab_r3_c5: {
    outbrain: { ...outbrainMixins.AR_38 },
    style: { ...styleMixins[304_300] },
    taboola: getNTPTaboolaWidgetForPlacement('sectiontab-r3-c5'),
    assertive: {},
    props: {},
  },
  sectiontab_slider_1: {
    outbrain: {
      ...outbrainMixins.AR_27,
    },
    style: {
      ...styleMixins[304_612],
    },
    taboola: {},
    assertive: {},
    props: {
      lazyRender: true,
    },
  },
  sectiontab_slider_2: {
    outbrain: {
      ...outbrainMixins.AR_27,
    },
    style: {
      ...styleMixins[304_612],
    },
    taboola: {},
    assertive: {},
    props: {
      lazyRender: true,
    },
  },
  sectiontab_slider_3: {
    outbrain: {
      ...outbrainMixins.AR_27,
    },
    style: {
      ...styleMixins[304_612],
    },
    taboola: {},
    assertive: {},
    props: {
      lazyRender: true,
    },
  },
  // Homepage placements
  newtab_r1_c2: {
    outbrain: {
      ...outbrainMixins.AR_35,
    },
    style: {
      ...styleMixins[304_300],
    },
    taboola: getNTPTaboolaWidgetForPlacement('r1-c2'),
    assertive: {},
    props: {},
  },
  newtab_r1_topright: {
    outbrain: {
      ...outbrainMixins.AR_36,
    },
    style: {
      ...styleMixins[304_300],
    },
    taboola: getNTPTaboolaWidgetForPlacement('r1-topright'),
    assertive: {},
    props: {},
  },
  newtab_r2_c1: {
    outbrain: {
      ...outbrainMixins.AR_37,
    },
    style: {
      ...styleMixins[304_300],
    },
    taboola: getNTPTaboolaWidgetForPlacement('r2-c1'),
    assertive: {},
    props: {},
  },
  newtab_r3_right: {
    outbrain: {
      ...outbrainMixins.AR_45,
    },
    style: {
      ...styleMixins[304_300],
    },
    taboola: getNTPTaboolaWidgetForPlacement('r3-right'),
    assertive: {},
    props: {
      lazyRender: true,
    },
  },
  newtab_r4_c1: {
    outbrain: {
      // TODO: @alexannmill TEMP! these are endless replace once new widgets are ready
      ...outbrainMixins.AR_38,
    },
    style: {
      ...styleMixins[304_300],
    },
    taboola: getNTPTaboolaWidgetForPlacement('r4-c1'),
    assertive: {},
    props: {
      lazyRender: true,
    },
  },
  newtab_r4_right: {
    outbrain: {
      // TODO: @alexannmill TEMP! these are endless replace once new widgets are ready
      ...outbrainMixins.AR_38,
    },
    style: {
      ...styleMixins[304_300],
    },
    taboola: getNTPTaboolaWidgetForPlacement('r4-right'),
    assertive: {},
    props: {
      lazyRender: true,
    },
  },
  newtab_r3_c1: {
    outbrain: {
      ...outbrainMixins.AR_38,
    },
    style: {
      ...styleMixins[304_300],
    },
    taboola: getNTPTaboolaWidgetForPlacement('r3-c1'),
    assertive: {},
    props: {
      lazyRender: true,
    },
  },
  newtab_r2_c4: {
    outbrain: {
      ...outbrainMixins.AR_38,
    },
    style: {
      ...styleMixins[304_300],
    },
    taboola: getNTPTaboolaWidgetForPlacement('r2-c4'),
    assertive: {},
    props: {
      lazyRender: true,
    },
  },
  newtab_endless_right: {
    outbrain: {
      ...outbrainMixins.AR_38,
    },
    style: {
      ...styleMixins[304_300],
    },
    taboola: getNTPTaboolaWidgetForPlacement('endless'),
    assertive: {},
    props: {
      lazyRender: true,
    },
  },
  newtab_slider_1: {
    outbrain: {
      ...outbrainMixins.AR_27,
    },
    style: {
      ...styleMixins[304_612],
    },
    taboola: {},
    assertive: {},
    props: {
      lazyRender: true,
    },
  },
  newtab_slider_2: {
    outbrain: {
      ...outbrainMixins.AR_27,
    },
    style: {
      ...styleMixins[304_612],
    },
    taboola: {},
    assertive: {},
    props: {
      lazyRender: true,
    },
  },
  newtab_leaderboard: {
    outbrain: {},
    taboola: {},
    assertive: {},
    style: {
      ...styleMixins['400_FULL'],
    },
    props: {
      lazyRender: true,
    },
  },
  newtab_leaderboard_mb: {
    outbrain: {},
    taboola: {},
    assertive: {},
    style: {
      ...styleMixins[100_300],
    },
    props: {
      lazyRender: true,
    },
  },

  // Article page placements
  article_hero: {
    outbrain: {},
    taboola: {},
    assertive: {},
    style: {
      ...styleMixins['310_FULL'],
    },
    props: {
      sticky: true,
    },
  },
  article_hero_mb: {
    outbrain: {},
    taboola: {},
    assertive: {},
    style: {
      ...styleMixins[100_300],
    },
    props: {
      sticky: true,
    },
  },
  article_content_below_button: {
    outbrain: {
      ...outbrainMixins.AR_31,
    },
    taboola: {
      ...taboolaMixins.article_content_below_button,
    },
    assertive: {},
    style: {
      ...styleMixins.auto,
    },
    props: {},
  },
  article_content_middle: {
    outbrain: {},
    taboola: {},
    assertive: {},
    style: {
      ...styleMixins['400_FULL'],
    },
    props: {},
  },
  article_content_middle_mb: {
    outbrain: {},
    taboola: {},
    assertive: {},
    style: {
      ...styleMixins['310_FULL'],
    },
    props: {
      lazyRender: true,
    },
  },
  article_siderail_top: {
    outbrain: {},
    taboola: {},
    assertive: {},
    style: {
      ...styleMixins[290_340],
    },
    props: {},
  },
  article_siderail_middle: {
    outbrain: {
      // ...outbrainMixins.SB_2,
    },
    taboola: {
      // ...taboolaMixins.article_siderail_middle,
    },
    assertive: {},
    style: {
      ...styleMixins[290_340],
    },
    props: {},
  },
  article_siderail_bottom: {
    outbrain: {},
    taboola: {},
    assertive: {},
    style: {},
    props: {},
  },
  article_content_top: {
    outbrain: {},
    taboola: {},
    assertive: {},
    style: {},
    props: {},
  },
  article_content_below_image: {
    outbrain: {},
    taboola: {},
    assertive: {},
    style: {},
    props: {},
  },
  article_content_above_button: {
    outbrain: {},
    taboola: {},
    assertive: {},
    style: {},
    props: {},
  },
}
